/* eslint-disable react/prop-types */
//

import { Box, Card, Grid, Typography } from '@mui/material';
import { border, styled } from '@mui/system';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import LeadGenerationContext from '../../context/LeadGenerationContext';

import { AnotherBankLogo, OrientalLogoRound } from '../../images/svg/CustomizedSVG';
import { isPlaidProduct } from '../commonCode';
import { LayoutStyles as bundleClasses } from './LayoutStyles';

const StyledCard = styled(Card)(({ theme, isActive }) => ({
  borderRadius: '24px',
  border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
  // background: '#FFF',

  cursor: 'pointer',
  transition: 'all 0.3s ease',
  // maxWidth: '150px',
  // width: '100%',
  textAlign: 'center',
  margin: '20px 0',

  ...(isActive && {
    border: `2px solid ${theme?.palette?.orientalPrimary?.main} !important`,
    background: `${theme?.palette?.cardActiveBackground?.main} !important`,
  }),
}));

const CustomSwitchFunding = ({ handleToggleOri, handleToggleAnother }) => {
  const leadGenerationContext = LeadGenerationContext;

  const {
    fundData,
    plaidDetails,
    statementUploadLoading,
    statementUploadStatus,
    statementDocumentId,
    theme,
  } = useContext(LeadGenerationContext);
  const { t } = useTranslation();

  const disabledContition =
    plaidDetails?.status === 'Pending' ||
    plaidDetails?.status === 'Success' ||
    (statementDocumentId !== null && statementUploadStatus !== null) ||
    (statementUploadLoading && isPlaidProduct(leadGenerationContext.productName));

  return (
    <Grid container width="100%" spacing={2}>
      <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
        <StyledCard
          tabIndex="0"
          variant="outlined"
          name="oriental account"
          data-testid="orientalAccount_id"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleToggleOri(e);
            }
          }}
          aria-label="oriental account selected"
          isActive={fundData?.orientalAccount}
          sx={{
            opacity: disabledContition ? 0.5 : 1,
            pointerEvents: disabledContition ? 'none' : 'auto',
            cursor: disabledContition ? 'default' : 'pointer',

            backgroundColor: theme?.palette?.fieldsBackground?.main,
            border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
            color: theme?.palette?.primary?.main,
          }}
          // InputClassName={DisableSwitch && `${classes.disableSwitch}`}
          id="orientalAccount"
          ariaLabelName={t('Oriental Account', {
            defaultValue: 'Oriental Account',
          })}
          defaultData={fundData?.orientalAccount}
          ariaLabelledby="toggleone"
          onClick={handleToggleOri}
        >
          <Box component="div" sx={bundleClasses.customSwitchFunding}>
            <OrientalLogoRound height="32" width="32" />
            &ensp;
            <Typography variant="subtitle1" sx={bundleClasses.customSwitchFundingText}>
              {t('Oriental Account', {
                defaultValue: 'Oriental Account',
              })}
            </Typography>
          </Box>
        </StyledCard>
      </Grid>
      <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
        <StyledCard
          tabIndex="0"
          variant="outlined"
          name="another bank account"
          data-testid="anotherBankAccount_id"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleToggleAnother(e);
            }
          }}
          sx={{
            opacity: disabledContition ? 0.5 : 1,
            pointerEvents: disabledContition ? 'none' : 'auto',
            cursor: disabledContition ? 'default' : 'pointer',
            backgroundColor: theme?.palette?.fieldsBackground?.main,
            border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
            color: theme?.palette?.primary?.main,
          }}
          aria-label={t('Another Bank Account', {
            defaultValue: 'Another Bank Account',
          })}
          isActive={fundData?.anotherBankAccount}
          id="anotherBankAccount"
          // defaultData={fundData?.anotherBankAccount}
          aria-labelledby="toggletwo"
          onClick={handleToggleAnother}
        >
          <Box component="div" sx={bundleClasses.customSwitchFunding}>
            <AnotherBankLogo color={theme?.palette?.orientalPrimary?.main} />
            &ensp;
            <Typography variant="subtitle1" sx={bundleClasses.customSwitchFundingText}>
              {t('Another Bank Account', {
                defaultValue: 'Another Bank Account',
              })}
            </Typography>
          </Box>
        </StyledCard>
      </Grid>
    </Grid>
  );
};

export default CustomSwitchFunding;
